angular.module('app').directive('replaceNbsp', ['$timeout', function ($timeout) {
    return {
        //scope: true,   // optionally create a child scope
        restrict: "A",
        require: '?ngModel',
        replace: true,
        link: function (scope, element, attrs,ngModel) {
            element.on("paste", function () {
                $timeout(function () {
                    var value = ngModel.$viewValue;
                    value = value.replace(/&nbsp;|\u00a0/g, " ");
                    ngModel.$setViewValue(value);
                    ngModel.$render();
                });

            });

        }
    };
}]);